import { Cookies } from 'react-cookie';

/**
 * Fetch data from given url
 * @param {*} url
 * @param {*} options
 */
const fetchJSON = (url, options = {}) => {
    const cookies = new Cookies();
    const csrftoken = cookies.get('csrftoken');

    if(csrftoken) {
        options.headers['X-CSRFToken'] = csrftoken;
    }
    
    return fetch(url, options)
        .then(response => {
            if (response.status !== 200) {
                return Promise.reject(response);
            }
            return response.json();
        })
        .then(json => {
            return json;
        })
        .catch(response => {
            return response.json().then((json) => {
                throw json;
            })
        });
};

export { fetchJSON };
